import { Button, Spinner } from 'avo-ui'
import { GeneralInfo } from 'components/product/brand-create/general-info/GeneralInfo'
import { BannerPromoBrandContainer } from '../../../containers/product/brand-create/banner-promo-brand/BannerPromoBrandContainer'
import { ProductHighlightContainer } from '../../../containers/product/brand-create/product-highlight/ProductHighlightContainer'

export const BrandCreate = ({
    sectionProps,
    isUpdate,
    isLoading,
    isLoadingUpload,
    isCreating,
    isUpdating,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <GeneralInfo {...sectionProps} />
                        <BannerPromoBrandContainer {...sectionProps} />
                        {isUpdate && <ProductHighlightContainer {...sectionProps} />}
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isCreating || isUpdating}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
